import axios from 'axios'

let file_name, file_path //文件名称和上传后的文件路径
const ossData = new Object() //用来存储请求get.php的数据
// axios.post('https://www.artbook.top/apps/oss-h5/php/get.php', {
//   dir: 'enlightv'
// }).then(res => {
//   ossData.domain = res.data['domain']
//   ossData.host = res.data['host']
//   ossData.policy = res.data['policy']
//   ossData.OSSAccessKeyId = res.data['accessid']
//   ossData.signature = res.data['signature']
//   ossData.expire = parseInt(res.data['expire'])
//   ossData.callback = res.data['callback']
//   ossData.key = res.data['dir']
// }).catch(err => {
//   if (!err.response) {
//     // alert('post请求')
//     // Message({
//     //   showClose: true,
//     //   message: 'post请求错误',
//     //   type: 'error'
//     // });
//   } else {
//     reject(err.data)
//     console.log(err.response, '异常2')
//   }
// })

export const get_suffix = (filename) => {
  var pos = filename.lastIndexOf('.')
  var suffix = ''
  if (pos != -1) {
    suffix = filename.substring(pos)
  }
  return suffix
}

export const random_string = (len) => {
  len = len || 32
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  var maxPos = chars.length
  var pwd = ''
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}



export const uploadImg = (file, fileSize) => {
  if(file){
    return new Promise(function(resolve, reject) {
      //1。 请求服务端获取上传地址 POST JSON
      let postData = {
        content_type:file.type ? file.type : '*/*',
        file_name:file.name
      }
        axios.post('https://uploads.enlightv.com/get_upload_url', postData).then(res => {
          if(res.data.upload_url){
            axios.put(res.data.upload_url, file, {
              headers: {
                "Content-Type": file.type ? file.type : '*/*',
                'x-oss-storage-class': 'Standard',
              }
            })
              .then(function(response) {
                // 处理成功
                let returnData={
                  file_path:res.data.url,
                  file_name:file.name,
                  file_type:file.type
                }
                resolve(returnData)
              })
              .catch(function(error) {
                // 处理错误
              });
          }
        }).catch(err => {
          if (!err.response) {

          } else {
            reject(err.data)
          }
        })
    })
  } else {
    return new Promise(function (resolve, reject) {
      reject()
    })
  }
}

// export const uploadImg = (file, fileSize) => {
//   if (ossData.OSSAccessKeyId) {
//     let key = ossData.key + random_string(20) + get_suffix(file.name)
//     let params = new FormData()
//     params.append('key', key)
//     params.append('policy', ossData.policy)
//     params.append('OSSAccessKeyId', ossData.OSSAccessKeyId)
//     params.append('success_action_status', 200)
//     params.append('callback', ossData.callback)
//     params.append('signature', ossData.signature)
//     params.append('file', file)
//     return new Promise(function (resolve, reject) {
//       axios.post(ossData.host, params).then(res => {
//         file_path = ossData.domain + key
//         file_name = file.name
//         let returnData = {
//           file_path: file_path,
//           file_name: file_name,
//           file_type: file.type
//         }
//         resolve(returnData)
//       }).catch(err => {
//         if (!err.response) {
//
//         } else {
//           reject(err.data)
//         }
//       })
//     })
//   } else {
//     return new Promise(function (resolve, reject) {
//       reject()
//     })
//   }
// }

export const getOSSData = (filePath, fileName) => {
    window.location.href = `${filePath}?response-content-disposition=attachment%3B%20filename%3D${fileName}`
}
